import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Package, Search, Filter, ArrowRight, Star, ChevronDown } from 'lucide-react';
import Navbar from '../layout/Navbar';
import Footer from '../layout/Footer';
import basemati_rice from '../assets/agriculture_product/basmati_rice.png';
import chicken_egg from '../assets/agriculture_product/chicken_egg.png';
import corn_seeds from '../assets/agriculture_product/corn_seeds.png';
import guar_gum from '../assets/agriculture_product/guar_gum.png';
import onion from '../assets/agriculture_product/onion.png';
import pulses from '../assets/agriculture_product/pulses.png';
import sesame_seeds from '../assets/agriculture_product/sesame_seeds.png';
import wheat from '../assets/agriculture_product/wheat.png';
import groundnut from '../assets/agriculture_product/groundnut.png';
import cumin_seeds from '../assets/spice_product/cumin_seeds.png';
import coriander_seeds from '../assets/spice_product/coriander_seeds.png';
import fennel_seeds1 from '../assets/spice_product/fennel_seeds1.png';
import chili_powder from '../assets/spice_product/chili_powder.png';
import coriander_powder from '../assets/spice_product/coriander_powder.png';
import turmeri_powder from '../assets/spice_product/turmeri_powder.png';
import cumin_powder from '../assets/spice_product/cumin_powder.png';
import cotton from '../assets/agriculture_product/Cotton.jpg';

const Products = () => {
    const navigate = useNavigate();
    const [isVisible, setIsVisible] = useState({});
    const [activeCategory, setActiveCategory] = useState("All");
    const [searchQuery, setSearchQuery] = useState(""); // Search state add kiya

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsVisible((prev) => ({ ...prev, [entry.target.id]: true }));
                    }
                });
            },
            { threshold: 0.1 }
        );

        const elements = document.querySelectorAll('.animate-on-scroll');
        elements.forEach((el) => observer.observe(el));

        return () => observer.disconnect();
    }, []);

    const categories = ["All", "Agriculture", "Spices", "Textiles"];

    const products = [
        // Agriculture Products
        {
            id: 1,
            name: "Premium Basmati Rice",
            category: "Agriculture",
            image: basemati_rice,
            description: "Extra long grain aromatic basmati rice, perfect for international cuisines.",
            rating: 5
        },
        {
            id: 2,
            name: "Wheat",
            category: "Agriculture",
            image: wheat,
            description: "Premium quality wheat grains sourced from premium agricultural farms, ideal for flour and grain production.",
            rating: 5
        },
        {
            id: 3,
            name: "Onion",
            category: "Agriculture",
            image: onion,
            description: "Fresh, premium quality onions with excellent shelf life, perfect for domestic and international markets.",
            rating: 5
        },
        {
            id: 4,
            name: "Sesame Seeds",
            category: "Agriculture",
            image: sesame_seeds,
            description: "High-quality sesame seeds rich in minerals and oils, ideal for culinary and industrial applications.",
            rating: 5
        },
        {
            id: 5,
            name: "Pulses",
            category: "Agriculture",
            image: pulses,
            description: "Assorted premium pulses including lentils and legumes, rich in protein and nutrients.",
            rating: 5
        },
        {
            id: 6,
            name: "Groundnut",
            category: "Agriculture",
            image: groundnut,
            description: "High-quality groundnuts/peanuts sourced from certified farms, perfect for snacking and oil production.",
            rating: 5
        },
        {
            id: 7,
            name: "Corn Seeds",
            category: "Agriculture",
            image: corn_seeds,
            description: "Premium hybrid corn seeds with high germination rates, ideal for agricultural cultivation.",
            rating: 5
        },
        {
            id: 8,
            name: "Guar Gum",
            category: "Agriculture",
            image: guar_gum,
            description: "Pure guar gum powder extracted from guar beans, widely used in food and industrial applications.",
            rating: 5
        },
        {
            id: 9,
            name: "Chicken Egg",
            category: "Agriculture",
            image: chicken_egg,
            description: "Fresh, hygienic chicken eggs sourced from certified farms, rich in protein and nutrients.",
            rating: 5
        },
        // Textile Product
        {
            id: 10,
            name: "Cotton Yarn",
            category: "Textiles",
            image: cotton,
            description: "High-quality organic cotton yarn suitable for premium fabric manufacturing.",
            rating: 5
        },
        // Spice Products
        // {
        //     id: 11,
        //     name: "Spices Collection",
        //     category: "Spices",
        //     image: "https://images.unsplash.com/photo-1596040033229-a9821ebd058d?auto=format&fit=crop&q=80&w=800",
        //     description: "Authentic blend of premium spices sourced directly from farmers.",
        //     rating: 5
        // },
        {
            id: 12,
            name: "Cumin Seeds",
            category: "Spices",
            image: cumin_seeds,
            description: "Pure cumin seeds with authentic aroma and flavor, perfect for cooking and culinary purposes.",
            rating: 5
        },
        {
            id: 13,
            name: "Coriander Seeds",
            category: "Spices",
            image: coriander_seeds,
            description: "Premium coriander seeds with strong aromatic properties, ideal for spice blends and cooking.",
            rating: 5
        },
        {
            id: 14,
            name: "Fennel Seeds",
            category: "Spices",
            image: fennel_seeds1,
            description: "High-quality fennel seeds with natural sweetness, widely used in cooking and beverages.",
            rating: 5
        },
        {
            id: 15,
            name: "Chili Powder",
            category: "Spices",
            image: chili_powder,
            description: "Pure chili powder made from selected red chilies, adding perfect heat and color to dishes.",
            rating: 5
        },
        {
            id: 16,
            name: "Coriander Powder",
            category: "Spices",
            image: coriander_powder,
            description: "Fine coriander powder ground from premium seeds, essential for authentic Indian cooking.",
            rating: 5
        },
        {
            id: 17,
            name: "Turmeric Powder",
            category: "Spices",
            image: turmeri_powder,
            description: "Pure turmeric powder rich in curcumin, used for cooking and health benefits.",
            rating: 5
        },
        {
            id: 18,
            name: "Cumin Powder",
            category: "Spices",
            image: cumin_powder,
            description: "Ground cumin powder with authentic flavor, perfect for seasoning and spice mixes.",
            rating: 5
        },
    ];

    // Category aur Search dono se filter karo
    const filteredProducts = products.filter(product => {
        const matchesCategory = activeCategory === "All" || product.category === activeCategory;
        const matchesSearch = product.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
            product.description.toLowerCase().includes(searchQuery.toLowerCase());
        return matchesCategory && matchesSearch;
    });

    return (
        <>
            <Navbar />
            <div className="min-h-screen bg-gray-50">
                {/* Hero Section */}
                <section className="relative bg-gradient-to-br from-green-900 via-emerald-900 to-teal-900 text-white overflow-hidden">
                    <div className="absolute inset-0 bg-black opacity-30"></div>
                    <div className="absolute inset-0">
                        <div className="absolute top-20 left-10 w-96 h-96 bg-green-500 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob"></div>
                        <div className="absolute bottom-20 right-10 w-96 h-96 bg-emerald-500 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000"></div>
                    </div>

                    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 text-center">
                        <h1 className="text-4xl md:text-6xl font-bold mb-6 animate-fade-in-down">
                            Our <span className="text-green-400">Products</span>
                        </h1>
                        <p className="text-xl text-green-100 max-w-2xl mx-auto animate-fade-in-up">
                            Discover our diverse range of high-quality export products sourced from the best manufacturers.
                        </p>
                    </div>
                </section>

                {/* Filter & Search Section */}
                <section className="bg-white shadow-md border-b border-gray-100">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
                        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                            <div className="flex overflow-x-auto w-full md:w-auto pb-2 md:pb-0 gap-2 no-scrollbar">
                                {categories.map((category) => (
                                    <button
                                        key={category}
                                        onClick={() => setActiveCategory(category)}
                                        className={`px-6 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap ${activeCategory === category
                                            ? 'bg-green-600 text-white shadow-lg transform scale-105'
                                            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                                            }`}
                                    >
                                        {category}
                                    </button>
                                ))}
                            </div>

                            <div className="relative w-full md:w-64">
                                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
                                <input
                                    type="text"
                                    placeholder="Search products..."
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    className="w-full pl-10 pr-4 py-2 rounded-full border border-gray-200 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                />
                            </div>
                        </div>
                    </div>
                </section>

                {/* Products Grid */}
                <section className="py-16">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        {filteredProducts.length === 0 ? (
                            <div className="text-center py-20">
                                <Package className="w-16 h-16 text-gray-300 mx-auto mb-4" />
                                <h3 className="text-2xl font-semibold text-gray-600 mb-2">No products found</h3>
                                <p className="text-gray-500">Try adjusting your filters or search query</p>
                            </div>
                        ) : (
                            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                                {filteredProducts.map((product, index) => (
                                    <div
                                        key={product.id}
                                        id={`product-${product.id}`}
                                        className="animate-on-scroll group bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden transform hover:-translate-y-2 transition-all duration-300"
                                        style={{
                                            opacity: isVisible[`product-${product.id}`] ? 1 : 0,
                                            transform: isVisible[`product-${product.id}`] ? 'translateY(0)' : 'translateY(30px)',
                                            transition: `all 0.4s ease-out ${index * 0.05}s`
                                        }}
                                    >
                                        <div className="relative h-64 overflow-hidden bg-white p-4">
                                            <img
                                                src={product.image}
                                                alt={product.name}
                                                className="w-full h-full object-contain mix-blend-multiply transform group-hover:scale-110 transition-transform duration-500"
                                            />
                                            <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-semibold text-green-800">
                                                {product.category}
                                            </div>
                                        </div>

                                        <div className="p-6">
                                            <div className="flex justify-between items-start mb-2">
                                                <h3 className="text-xl font-bold text-gray-900 group-hover:text-green-600 transition-colors">
                                                    {product.name}
                                                </h3>
                                                <div className="flex gap-1">
                                                    {[...Array(product.rating)].map((_, i) => (
                                                        <Star key={i} className="w-4 h-4 text-yellow-400 fill-current" />
                                                    ))}
                                                </div>
                                            </div>

                                            <p className="text-gray-600 mb-6 line-clamp-2">
                                                {product.description}
                                            </p>

                                            <button
                                                onClick={() => navigate(`/product/${product.id}`)}
                                                className="w-full bg-green-50 text-green-600 py-3 rounded-xl font-semibold hover:bg-green-600 hover:text-white transition-all duration-300 flex items-center justify-center gap-2 group-hover:shadow-md">
                                                View Details
                                                <ArrowRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform" />
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </section>

                {/* Call to Action */}
                <section className="py-20 bg-gradient-to-r from-green-600 to-emerald-700 text-white">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                        <div className="max-w-3xl mx-auto">
                            <h2 className="text-3xl md:text-5xl font-bold mb-6">
                                Can't Find What You're Looking For?
                            </h2>
                            <p className="text-xl text-green-100 mb-8">
                                We have an extensive network of suppliers. Contact <span className="font-semibold text-white">Nurani Enterprise</span> with your specific requirements.
                            </p>
                            <button className="bg-white text-green-600 px-8 py-4 rounded-full font-bold text-lg hover:bg-green-50 transform hover:scale-105 transition-all duration-300 shadow-xl">
                                Request Product Source
                            </button>
                        </div>
                    </div>
                </section>

                <style jsx>{`
                    @keyframes fade-in-down {
                        from { opacity: 0; transform: translateY(-20px); }
                        to { opacity: 1; transform: translateY(0); }
                    }
                    @keyframes fade-in-up {
                        from { opacity: 0; transform: translateY(20px); }
                        to { opacity: 1; transform: translateY(0); }
                    }
                    @keyframes blob {
                        0%, 100% { transform: translate(0, 0) scale(1); }
                        33% { transform: translate(30px, -50px) scale(1.1); }
                        66% { transform: translate(-20px, 20px) scale(0.9); }
                    }
                    .animate-fade-in-down { animation: fade-in-down 1s ease-out; }
                    .animate-fade-in-up { animation: fade-in-up 1s ease-out 0.3s both; }
                    .animate-blob { animation: blob 7s infinite; }
                    .animation-delay-2000 { animation-delay: 2s; }
                    .no-scrollbar::-webkit-scrollbar { display: none; }
                    .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
                `}</style>
            </div>
            <Footer />
        </>
    );
};

export default Products;